'use client';

import React, { memo, useMemo } from 'react';
import { useRouter } from 'next/navigation';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string; // Image source (optional)
  iconName?: string; // Icon name when no image
  size?: number; // Size for icon/image
  className?: string; // Additional classes
  onClick?: () => void; // Click handler
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/app_logo.png',
  iconName = 'SparklesIcon',
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const router = useRouter();

  const handleClick = onClick ?? (() => router.push('/dashboard'));

  // Memoize className calculation
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center', 'cursor-pointer hover:opacity-80 transition-opacity'];
    if (className) classes.push(className);
    return classes.join(' ');
  }, [className]);

  return (
    <div className={containerClassName} onClick={handleClick}>
      {/* Show image if src provided, otherwise show icon */}
      {src ? (
        <AppImage
          src={src}
          alt="Logo" 
          width={size}
          height={size}
          className="flex-shrink-0"
          priority={true}
          unoptimized={src.endsWith('.svg')}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}
    </div>
  );
});

export default AppLogo;
